module.exports = [{
      plugin: require('/tmp/51738a61/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('/tmp/51738a61/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
